var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import PageHeader from "../../components/PageHeader";
import images from "../../utils/Images";
import icons from "../../utils/Icons";
import ImageThumbnail from "../../components/ImageThumbnail";
import PrimaryButton from "../../components/Button/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { clearPost, setPost } from "../../store/slices/postSlice";
import axios from "axios";
import Spinner from "../../components/Spinner";
import FaceImage from "../../components/cloudinary/FaceImage";
var CreatePost = function () {
    var publicId = useSelector(function (state) { return state.user.publicId; });
    var username = useSelector(function (state) { return state.user.username; });
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var draftPost = useSelector(function (state) { return state.post; });
    var _a = useState(false), uploading = _a[0], setUploading = _a[1];
    var _b = useState(0), progress = _b[0], setProgress = _b[1];
    var _c = useState(null), thumbnail = _c[0], setThumbnail = _c[1];
    var _d = useState(false), postLoading = _d[0], setPostLoading = _d[1];
    var _e = useState({
        caption: "",
        publicId: null,
        videoId: "",
        fileType: null,
        fileUrl: null,
        fileId: null,
    }), postData = _e[0], setPostData = _e[1];
    useEffect(function () {
        console.log(draftPost, "draft post");
        if (draftPost.caption) {
            loadDraft();
        }
    }, [draftPost.caption]);
    // useEffect(() => {
    //     return () => {
    //         postData.previewUrls.forEach((url) => URL.revokeObjectURL(url));
    //     };
    // }, [postData.files]);
    var filterHandle = function () {
        console.log("saving...");
    };
    var handleSubmit = function () {
        var _a, _b;
        if (postData.fileId === null) {
            toast.error("Please upload a file");
            return;
        }
        console.log("Files to upload:", postData);
        var formData = new FormData();
        formData.append("caption", postData.caption);
        if (postData.fileType === "video") {
            formData.append("video_id", ((_a = postData.fileId) === null || _a === void 0 ? void 0 : _a.toString()) || "");
        }
        else {
            formData.append("image_id", ((_b = postData.fileId) === null || _b === void 0 ? void 0 : _b.toString()) || "");
        }
        setPostLoading(true);
        axios
            .post("/posts/save", formData)
            .then(function (response) {
            toast.success("Post saved successfully");
            navigate("#/social");
        })
            .catch(function (error) {
            console.error("Upload failed:", error);
        })
            .finally(function () {
            setPostLoading(false);
        });
        dispatch(clearPost());
    };
    var postDataHandle = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        setPostData(__assign(__assign({}, postData), (_a = {}, _a[name] = value, _a)));
    };
    var uploadFileHandle = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var files, formData;
        return __generator(this, function (_a) {
            files = e.target.files;
            console.log(name, " ==> ", files);
            if (files) {
                // const newFiles = Array.from(files);
                // const newPreviewUrls = newFiles.map((file) =>
                //     URL.createObjectURL(file)
                // );
                setUploading(true);
                setProgress(0);
                formData = new FormData();
                formData.append("file", files[0]);
                axios
                    .post("/images/save_social_image", formData, {
                    onUploadProgress: function (progressEvent) {
                        var progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                        setProgress(progress);
                    },
                })
                    .then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                    var thumb;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                setPostData(function (prev) { return (__assign(__assign({}, prev), { publicId: response.data.public_id, fileType: response.data.type, fileUrl: response.data.url, fileId: response.data.file.id })); });
                                if (!(response.data.type == "video")) return [3 /*break*/, 2];
                                return [4 /*yield*/, generateThumbnail(files[0])];
                            case 1:
                                thumb = _a.sent();
                                setThumbnail(thumb);
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); })
                    .catch(function (error) {
                    console.error("Upload failed:", error);
                    toast.error("Upload failed");
                })
                    .finally(function () {
                    setUploading(false);
                });
            }
            return [2 /*return*/];
        });
    }); };
    var generateThumbnail = function (file) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var url = URL.createObjectURL(file);
                    var video = document.createElement("video");
                    video.src = url;
                    video.crossOrigin = "anonymous";
                    // When metadata is loaded, set the current time to capture the frame
                    video.addEventListener("loadedmetadata", function () {
                        // Seek to 1 second (you can adjust this time as needed)
                        video.currentTime = 1;
                    });
                    // Once the video seeks to the desired time, capture the frame
                    video.addEventListener("seeked", function () {
                        var canvas = document.createElement("canvas");
                        canvas.width = video.videoWidth;
                        canvas.height = video.videoHeight;
                        var context = canvas.getContext("2d");
                        if (context) {
                            context.drawImage(video, 0, 0, canvas.width, canvas.height);
                            var imageURL = canvas.toDataURL("image/jpeg");
                            resolve(imageURL);
                        }
                        else {
                            reject("Canvas context is null");
                        }
                    });
                    // Handle video errors
                    video.addEventListener("error", function () {
                        reject("Error loading video");
                    });
                })];
        });
    }); };
    var deleteFileHandle = function () {
        var _a;
        setUploading(true);
        setProgress(0);
        var formData = new FormData();
        formData.append("file_type", (postData === null || postData === void 0 ? void 0 : postData.fileType) || "");
        formData.append("file_id", ((_a = postData === null || postData === void 0 ? void 0 : postData.fileId) === null || _a === void 0 ? void 0 : _a.toString()) || "");
        formData.append("public_id", (postData === null || postData === void 0 ? void 0 : postData.publicId) || "");
        axios
            .post("/images/delete_social_image", formData, {
            onUploadProgress: function (progressEvent) {
                var progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                setProgress(progress);
            },
        })
            .then(function (response) {
            if (response.data.status == "success") {
                setPostData(__assign(__assign({}, postData), { publicId: null, fileUrl: null, fileType: null, fileId: null }));
            }
        })
            .catch(function (error) {
            console.error("File delete failed:", error);
        })
            .finally(function () {
            setUploading(false);
        });
    };
    var saveDraft = function () {
        if (postData.caption != "") {
            dispatch(setPost({
                caption: postData.caption,
                publicId: postData.publicId,
                videoId: postData.videoId,
                fileType: postData.fileType,
                fileUrl: postData.fileUrl,
                fileId: postData.fileId,
            }));
            toast.success("Draft saved successfully!");
        }
        navigate(-1);
    };
    var loadDraft = function () {
        setPostData({
            caption: draftPost.caption,
            publicId: draftPost.publicId,
            videoId: draftPost.videoId,
            fileType: draftPost.fileType,
            fileUrl: draftPost.fileUrl,
            fileId: draftPost.fileId,
        });
    };
    return (_jsxs("div", { children: [_jsx(PageHeader, { pageTitle: "Create Post" }), postLoading ? (_jsx(Spinner, {})) : (_jsxs("div", { className: "flex-1 overflow-y-auto custom-content-height px-[18px] py-[18px] bg-white", children: [_jsxs("div", { className: "flex gap-2.5 items-start max-w-full w-[357px]", children: [_jsxs("div", { className: "w-[30px] h-[30px] rounded-[50px] overflow-hidden", children: [publicId !== '' && _jsx(FaceImage, { publicId: publicId }), publicId === '' && _jsx("img", { src: images.user, alt: "" })] }), _jsx("div", { className: "flex flex-col flex-1 shrink basis-0 min-w-[240px]", children: _jsx("div", { className: "w-full whitespace-nowrap", children: _jsx("form", { children: _jsx("div", { className: "flex gap-1.5 items-center self-stretch my-auto", children: _jsxs("div", { className: " self-stretch my-auto", children: [_jsx("div", { className: "self-stretch my-auto text-base font-medium leading-none text-slate-900", children: username }), _jsx("div", { className: "mt-2 self-stretch my-auto text-base leading-none text-neutral-400", children: _jsxs("span", { className: "bg-[#F3F3F3] flex item-center  text-[#767676] py-1 rounded-[20px] px-2 text-[11px]", children: [_jsx("img", { src: icons.earth, alt: "" }), "Public", _jsx("img", { src: icons.arrowDown, alt: "" })] }) })] }) }) }) }) })] }), _jsxs("div", { className: "w-full my-4 ", children: [_jsx("label", { htmlFor: "email", className: "mb-3 text-[15px] font-[400]", children: "Caption" }), _jsx("textarea", { placeholder: "What's on your mind?", name: "caption", value: postData.caption, onChange: postDataHandle, rows: 3, className: "bg-white border border-[#E9E9E9] rounded-[12px] p-[13px] w-full" })] }), _jsxs("div", { className: "w-full my-4 ", children: [_jsx("label", { htmlFor: "email", className: "mb-3 text-[15px] font-[400]", children: "Upload File(Photo/Video)" }), _jsxs("div", { className: "mt-4 flex flex-wrap items-center gap-3", children: [!postData.fileUrl && _jsxs("div", { className: "relative", children: [_jsx("label", { htmlFor: "upload-file", children: _jsx("div", { className: "w-[72px] h-[72px] flex items-center justify-center overflow-hidden rounded-[8px] border-2 border-[#5898FD] border-dashed", children: _jsx("img", { className: "", src: icons.imagePlaceholder, alt: "" }) }) }), _jsx("input", { 
                                                // multiple={true}
                                                accept: "image/*,video/*", id: "upload-file", type: "file", className: "hidden", onChange: uploadFileHandle })] }), _jsxs("div", { className: "relative", children: [postData.fileUrl && (_jsx(ImageThumbnail, { allowDelete: true, classes: "shadow-md", imgSrc: postData.fileType === "image"
                                                    ? postData.fileUrl
                                                    : thumbnail, icon: icons.closeWhite, deleteActionHandle: function () {
                                                    return deleteFileHandle();
                                                } })), postData.fileType === "video" && (_jsx("div", { style: {
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                                                    borderRadius: "50%",
                                                    padding: "1px",
                                                }, children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "white", viewBox: "0 0 24 24", width: "24px", height: "24px", children: _jsx("path", { d: "M8 5v14l11-7z" }) }) }))] })] }), uploading && (_jsx("div", { children: _jsx("div", { className: "relative h-[10px] bg-[#e0e0e0] rounded-[5px] overflow-hidden mt-3", children: _jsx("div", { className: "h-[100%] bg-green-600 w-[0px] progress-bar-transition", style: { width: progress + "%" } }) }) })), !uploading && _jsxs("div", { className: "mt-4 flex w-full items-center gap-3", children: [_jsx(PrimaryButton, { title: "Cancel Draft", classes: "bg-[white] text-black px-3 w-full border border-[#EAEAEC] py-2", clickHandle: function () { return saveDraft(); } }), _jsx(PrimaryButton, { title: "Post", classes: "bg-[#5898FD] text-white w-full px-3 py-2", clickHandle: function () { return handleSubmit(); }, disabled: uploading })] }), uploading && (_jsx("div", { className: "mt-4 flex w-full items-center gap-3", children: _jsx(Spinner, {}) }))] })] }))] }));
};
export default CreatePost;
